import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=52581340&scoped=true&"
import script from "./CompanyEdit.vue?vue&type=script&lang=ts&"
export * from "./CompanyEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52581340",
  null
  
)

export default component.exports